import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Paper, TextField, Typography, InputLabel } from '@mui/material';
import AppBindStyles from '../../AppBindStyles';

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  }
});

class StepReseller extends React.Component {

  handleChange = (name, value) => {

    this.props.setResellerStateChanged(name, value );
 
  };

  login() {
    //grab the end of the current URL.  This ends up being the package name
    let currentURL = window.location.pathname;
    var n = currentURL.lastIndexOf("/") + 1;
    let returnTo = currentURL.substring(n, currentURL.length );
    let appParm = "so_" + currentURL.substring(n, currentURL.length );
    localStorage.setItem('app_parm', appParm);
    //this makes home go to buy subscription
    localStorage.setItem('subscriptionOrderLogin', returnTo);

    this.props.auth.login();
  }

  isInformationComplete() {

    const { validateEmail } = this.props.auth;

    if (this.props.reseller.companyName === '')
      return false;

    if (this.props.reseller.contactFirstName === '')
      return false;

    if (this.props.reseller.contactLastName === '')
      return false;

    if (this.props.reseller.contactEmail === '')
      return false;


    // Is email an email address?
    let emailOk = validateEmail(this.props.reseller.contactEmail);
    if (! emailOk)
      return false;

      return true;
  }

  isBackDisabled() {
    if (this.props.activeStep === 0)
      return true;

    return false;
  }

  isNextDisabled() {
    
    if (this.props.activeStep === this.props.assignedStep) {
      if (!this.isInformationComplete()) {
        return true;
      } 
    }
    return false;
  }


  render() {

    //console.log(JSON.stringify(this.props));
    const { validateEmail } = this.props.auth;

 
    let emailError = false;
    if (this.props.reseller.contactEmail != null && this.props.reseller.contactEmail !== '') {
      let emailOk = validateEmail(this.props.reseller.contactEmail);
      if (! emailOk) {
        emailError = true;
      }
    }  

    let displayOnly = false;
    if (this.props.activeStep > this.props.assignedStep) {
      displayOnly = true;
    } else if (this.props.displayOnly) {
      displayOnly = true;
    }

    if (!displayOnly) {
      return (

        <Grid container spacing={2}  >
          <Grid item xs={12}>
              <Typography variant="button">Purchasing agent</Typography>
          </Grid>
          <Grid item xs={12} style={{marginTop: -16}}>
            <TextField 
              id="company-name" label="Company *"
              value={ this.props.reseller.companyName }
              onChange={ (e) => this.handleChange('companyName', e.target.value) }
              inputProps={{ maxLength: 64 }}
            />
          </Grid>
          <Grid item  xs={12} sm={6}>
            <TextField  data-recording-ignore="mask"
              id="first-name" label="First name *"
              value={ this.props.reseller.contactFirstName }
              onChange={ (e) => this.handleChange('contactFirstName', e.target.value ) }
              inputProps={{ maxLength: 32 }}
            />
          </Grid>
          <Grid item  xs={12} sm={6}>
            <TextField  data-recording-ignore="mask"
              id="last-name" label="Last name *"
              value={ this.props.reseller.contactLastName }
              onChange={ (e) => this.handleChange('contactLastName', e.target.value ) }
              inputProps={{ maxLength: 32 }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField  data-recording-ignore="mask"
              id="email" label="Email *"
              error={emailError}
              value={ this.props.reseller.contactEmail }
              onChange={ (e) => this.handleChange('contactEmail', e.target.value ) }
            />
          </Grid>

          <Grid item xs={12}>
            <Paper  elevation={1} style={{marginTop: 16}}>
              <Grid container direction="row" justifyContent="space-between" alignItems="center" style={{padding: 16}}>
                <Grid item >
                    <Typography 
                      variant="body1"
                      noWrap
                      style={Object.assign({}, AppBindStyles.boldLabel, {marginRight: 8, minWidth: 25})}
                    >
                      Been here before?
                    </Typography>
                </Grid>
                <Grid item >
                  <Button color="primary" variant="outlined" onClick={this.login.bind(this)}>Log in</Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {this.props.activeStep === this.props.assignedStep &&
          <Grid item xs={12}>
          <Button
            disabled={this.isBackDisabled()}
            color="primary" variant="outlined"
            onClick={() => this.props.handleBack()}
            style={AppBindStyles.bottomButton}>
            Back
          </Button>
            <Button
              disabled={this.isNextDisabled()}
              color="primary" variant="contained"
              onClick={() => this.props.handleNext()}
              style={AppBindStyles.bottomButton}>
              Next
            </Button>
          </Grid>
          }
        </Grid>
          
      );
  
    } else {
      //display only
      return (

        <Grid container >
          <Grid item xs={12}>
            <InputLabel shrink style={{marginBottom:6}}>Purchasing agent</InputLabel>
            <Typography variant="body1" style={AppBindStyles.boldLabel}>
              {this.props.reseller.companyName}
            </Typography>
            <Typography variant="body2">
              {this.props.reseller.contactFirstName}&nbsp;{this.props.reseller.contactLastName}<br/>
              {this.props.reseller.contactEmail}
            </Typography>
          </Grid>

        </Grid>
          
      );

    }
  }
}


StepReseller.propTypes = {
  setResellerStateChanged: PropTypes.func.isRequired,
  assignedStep: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired
};

export default withStyles(styleSheet)(StepReseller);
